export default {
    name: 'DateTimeRangeInput',
    filter(col, filterForm) {
        return {
            input: 'oc-datetime-range-input',
            inputAttrs: {
                startDate: filterForm.startDate,
                endDate: filterForm.endDate
            },
            on: {
                'update:startDate': (event) => {
                    filterForm.set('startDate', event)
                },
                'update:endDate': (event) => {
                    filterForm.set('endDate', event)
                }
            }
        }
    }
}
